import { MetadataType } from '@aibees/elephant/hooks';
import { COMPANY_TYPE } from '../../search-table-company';
import { companyTypeFilterLabelParser } from '../components/filter-tags/utils';
import { FilterCategory, SearchFilterBase, SearchFilterType } from '../types';

export default function companyTypeFilterConfig(): SearchFilterBase {
  return {
    name: 'Company Type',
    icon: 'ic-type',
    index: 21,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.COMPANY_DATA],
    pinned: true,
    utils: {
      tags: {
        config: {
          showAsCard: true,
          tagsCardTitle: 'Type of Company',
        },
      },
    },
    items: [
      {
        name: 'Include',
        type: SearchFilterType.CUSTOM_SELECT,
        icon: undefined,
        index: 0,
        layer: 4,
        key: 'company_type_include_any',
        field: 'company_type_include_any',
        metadata: {
          color: 'primary',
          placeholder: 'Enter Company Type (OR) Search',
          autocomplete: {
            recent: false,
            checkboxPosition: 'left',
            multiple: true,
            customOptions: true,
          },
          metaDataApi: {
            enabled: true,
            key: MetadataType.COMPANY_TYPE,
          },
        },
        searchKey: 'value',
        config: { labelKey: 'label', valueKey: 'value' },
        open: true,
        utils: {
          tags: { labelFormatter: companyTypeFilterLabelParser },
        },
        treeOptions: COMPANY_TYPE_FILTER_OPTIONS,
      },
      {
        name: 'Exclude',
        type: SearchFilterType.CUSTOM_SELECT,
        icon: undefined,
        index: 0,
        layer: 4,
        key: 'company_type_exclude',
        field: 'company_type_exclude',
        metadata: {
          color: 'error',
          icon: 'block',
          placeholder: 'Enter Company Type (OR) Search',
          autocomplete: {
            recent: false,
            checkboxPosition: 'left',
            multiple: true,
            customOptions: true,
          },
          metaDataApi: {
            enabled: true,
            key: MetadataType.COMPANY_TYPE,
          },
        },
        searchKey: 'value',
        config: { labelKey: 'label', valueKey: 'value' },
        open: false,
        utils: {
          tags: { labelFormatter: companyTypeFilterLabelParser },
        },
        treeOptions: COMPANY_TYPE_FILTER_OPTIONS,
      },
    ],
  };
}

const getCompanyTypeOptions = () =>
  Object.values(COMPANY_TYPE).map((companyType) => ({
    id: companyType,
    value: companyType,
    label: companyTypeFilterLabelParser(companyType, companyType),
  }));

export const COMPANY_TYPE_FILTER_OPTIONS = [getCompanyTypeOptions()];
